import { Pipe, PipeTransform } from '@angular/core';
import { EntityStatus } from '@core';

import { LocationData } from '../../models';

@Pipe({ name: 'avsMarkerIcon' })
export class MarkerIconPipe implements PipeTransform {
  transform(site: LocationData): Node {
    const beachFlagImg = document.createElement('img');

    if (!site.incidentCountBySeverity) {
      beachFlagImg.src = 'assets/icons/marker-default.svg';

      return beachFlagImg;
    }

    let icon = 'good';

    if (site.status === EntityStatus.Paused) {
      icon = 'paused';
    } else if (site.incidentCountBySeverity.critical > 0 || site.incidentCountBySeverity.major > 0) {
      icon = 'error';
    } else if (site.incidentCountBySeverity.minor > 0) {
      icon = 'warning';
    }

    beachFlagImg.src = `assets/icons/marker-${icon}.svg`;

    return beachFlagImg;
  }
}
